<template>
  <section class="bq-advantage">
    <InfoBox
      :itemObj="item"
      :col="3"
      v-for="item in advantages"
      :key="item.advTitles"
      :classes="'advantage'"
    ></InfoBox>
    <!-- <div
      class="bq-advantage-item"
      v-for="item in advantages"
      :key="item.advTitles"
    >
      <img :src="item.iconUrl" alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome" class="bq-advantage-icon" />
      <div>{{ item.advTitles }}</div>
      <p>{{ item.advDesc }}</p>
    </div> -->
  </section>
</template>

<script>
import InfoBox from '@/components/website_v3/InfoBox';

export default {
  name: 'Advantage', // 核心优势

  data() {
    return {
      advantages: [
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1l_otCkT2gK0jSZFkXXcIQFXa-124-120.png',
          advTitles: '数据治理能力',
          advDesc:
            '针对数据潜在风险研究与规避，统一标准规范，高效处理提质，保障数据安全',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1onotCkT2gK0jSZFkXXcIQFXa-130-112.png',
          advTitles: '领先算法能力',
          advDesc:
            '基于阿里集团强大的算法能力，结合新兴技术长期开展“互联网+医疗健康”可操作性研究',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1Yl3nCXT7gK0jSZFpXXaTkpXa-116-114.png',
          advTitles: '丰富技术储备',
          advDesc:
            '长期与院士、高校等医疗团队合作储备丰富前沿技术，推进临床科研应用',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1glZsCoY1gK0jSZFCXXcwqXXa-124-122.png',
          advTitles: '强大运营能力',
          advDesc:
            '结合用户群体流量及线上支付能力高效践行“互联网+医疗健康”运营新模式',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB181QsChD1gK0jSZFKXXcJrVXa-116-116.png',
          advTitles: '持续创新能力',
          advDesc:
            '基于海量数据库，更敏锐察觉医疗行业的切入点和融合性持续探索智慧医疗新应用',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1EGQuCa61gK0jSZFlXXXDKFXa-112-112.png',
          advTitles: '全方位生态体系',
          advDesc:
            '基于阿里云、支付宝、阿里健康、钉钉等集团生态，全方位满足个性化需求',
        },
      ],
    };
  },
  components: {
    InfoBox,
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
